export default __webpack_public_path__ + "bdcd237d9529cb63e14c7d55ba9a1baa.png";